//@service
import { bind, RepositoryInterface } from '@/service/utils'
export const authService = {}


